import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["href"];
var _hoisted_6 = ["innerHTML"];
import { ref, onBeforeMount } from "vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'BlogBanner',
  props: {
    labels: {},
    blogBannerSb: {},
    isListing: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var blogBannerTitle = ref(null);
    var blogBannerDescription = ref(null);
    var selectedFilterForBlog = ref("");
    var blogLinkBuilt = ref("");
    var blogLinks = ["https://www.wikicasa.it/news/bonus-affitto-giovani-2023/", "https://www.wikicasa.it/news/piano-casa-2023/", "https://www.wikicasa.it/news/bonus-box-auto-2023/", "https://www.wikicasa.it/news/aste-immobiliari-cosa-sono-e-come-funzionano/", "https://www.wikicasa.it/news/bonus-balconi-2023/", "https://www.wikicasa.it/news/come-illuminare-il-giardino-casa-moderna/", "https://www.wikicasa.it/news/come-arredare-un-terrazzo-scoperto-alcune-idee/", "https://www.wikicasa.it/news/consigli-su-come-riutilizzare-i-tuoi-mobili-usati-dopo-un-trasloco/", "https://www.wikicasa.it/news/come-trasformare-la-tua-casa-in-un-appartamento-di-lusso/", "https://www.wikicasa.it/news/le-10-citta-con-piu-alta-percentuale-di-case-con-aria-condizionata/", "https://www.wikicasa.it/news/i-10-comuni-italiani-con-piu-case-con-piscina-in-vendita-vivi-lestate-al-massimo/", "https://www.wikicasa.it/news/mutui-prima-casa-under-36-le-novita-per-il-2023-2/"];
    onBeforeMount(function () {
      buildBlogBanner();
    });
    var buildBlogBanner = function buildBlogBanner() {
      buildBlogHref();
      if (Object.values(props.blogBannerSb).every(function (v) {
        return !v;
      })) {
        blogBannerTitle.value = props.labels.under36;
        blogBannerDescription.value = props.labels.under36_2;
        return;
      }
      if (props.isListing) {
        blogBannerTitle.value = props.labels.withFilterSelected;
        blogBannerDescription.value = props.labels.hereIsArticle;
      } else {
        blogBannerTitle.value = props.labels.thisRealEstateIs;
        blogBannerDescription.value = props.labels.hereIsArticle;
      }
      selectedFilterForBlog.value = props.blogBannerSb.isRent ? props.labels.forRent : props.blogBannerSb.isRestructured ? props.labels.tobeRestructured : props.blogBannerSb.haveBox ? props.labels.withBox : props.blogBannerSb.isAuction ? props.labels.inAuction : props.blogBannerSb.haveBalcony ? props.labels.withBalcony : props.blogBannerSb.haveGarden ? props.labels.withGarden : props.blogBannerSb.haveTerrace ? props.labels.withTerrace : props.blogBannerSb.isFurnished ? props.labels.furnished : props.blogBannerSb.isLuxury ? props.labels.luxury : props.blogBannerSb.haveAirConditioning ? props.labels.airConditioning : props.blogBannerSb.haveSwimmingPool ? props.labels.withSwimmingPool : "";
    };
    var buildBlogHref = function buildBlogHref() {
      blogLinkBuilt.value = props.blogBannerSb.isRent ? blogLinks[0] : props.blogBannerSb.isRestructured ? blogLinks[1] : props.blogBannerSb.haveBox ? blogLinks[2] : props.blogBannerSb.isAuction ? blogLinks[3] : props.blogBannerSb.haveBalcony ? blogLinks[4] : props.blogBannerSb.haveGarden ? blogLinks[5] : props.blogBannerSb.haveTerrace ? blogLinks[6] : props.blogBannerSb.isFurnished ? blogLinks[7] : props.blogBannerSb.isLuxury ? blogLinks[8] : props.blogBannerSb.haveAirConditioning ? blogLinks[9] : props.blogBannerSb.haveSwimmingPool ? blogLinks[10] : blogLinks[11];
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: "desktop-".concat(_ctx.isListing ? 'listing' : 'detail', "-blogbanner"),
        "class": _normalizeClass(["tw-text-left tw-rounded tw-border tw-border-w-lavender tw-px-20px tw-py-15px tw-bg-w-cultured tw-my-20px tw-text", {
          'tw-mx-15px sm:tw-mx-0': _ctx.isListing
        }])
      }, [_createElementVNode("p", {
        "class": "tw-inline",
        innerHTML: blogBannerTitle.value
      }, null, 8 /* PROPS */, _hoisted_2), _createTextVNode(" "), _createCommentVNode("\n    !"), selectedFilterForBlog.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        "class": "tw-font-semibold tw-lowercase",
        innerHTML: selectedFilterForBlog.value + '.'
      }, null, 8 /* PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true), _createElementVNode("p", {
        innerHTML: blogBannerDescription.value
      }, null, 8 /* PROPS */, _hoisted_4), _createVNode(BaseButton, {
        "class": "custom-hover",
        "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("a", {
            "data-cy": "read-blog-article-link",
            href: blogLinkBuilt.value,
            target: "_blank",
            "class": "!tw-text-inherit hover:!tw-text-inherit"
          }, [_createElementVNode("span", {
            innerHTML: _ctx.labels.readArticle
          }, null, 8 /* PROPS */, _hoisted_6)], 8 /* PROPS */, _hoisted_5)];
        }),
        _: 1 /* STABLE */
      })], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
});